export default __webpack_public_path__ + "static/media/TickIcon.1e15d797.png";